import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import CloneBot from "../../components/bots/CloneBot";
import Scrollbar from "../../components/Scrollbar";
import { useTranslation } from "../../hooks/useLocalization";

import useAnalytics from "../../hooks/useAnalytics";

const CloneBotModal = ({ bot, open, setOpen, onComplete }) => {
  const { t } = useTranslation();
  const { CONSOLE_EVENTS } = useAnalytics();
  const { id, name, description, isUpdating } = bot || {};
  const [createBotBridge, setOnSubmit] = useState({ onSubmit: null });
  const onClose = async () => {
    setOpen(false);
    await CONSOLE_EVENTS.EV_CloneBot.send({ action: 'close' })
  }
  return (
    <Modal show={open} onHide={onClose} enforceFocus={false}>
      <Helmet title={t("Clone Bot")} />
      <Modal.Header closeButton>{t("Clone")}</Modal.Header>
      <div className="modal-body-container ps-dark">
        <Scrollbar>
          <Modal.Body className="m-4">
            <CloneBot
              id={id}
              name={name}
              description={description}
              setOnSubmit={(onSubmit) => setOnSubmit({ onSubmit })}
              onComplete={(bot) => {
                setOpen(false);
                onComplete && onComplete(bot);
              }}
            />
          </Modal.Body>
        </Scrollbar>
      </div>
      <Modal.Footer>
        <Button disabled={!!isUpdating} variant="secondary" onClick={onClose}>
          {t("Close")}
        </Button>{" "}
        <Button disabled={!!isUpdating} variant="primary" onClick={createBotBridge.onSubmit} >
          {t("Clone Bot")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CloneBotModal;
